async function themeComponent(url, async=true, checkDom=false) {
  if(url == undefined || url == null){
    // se l'url non è definito
    return;
  }
  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('.js', '');
  // camelizza il nome del tag e metti in maiuscolo la prima lettera
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  
  // se il tag è già definito non lo carico
  if(!window[className] == undefined){
    return;
  }

  // se devo controllare il dom e non trovo il tag non lo carico
  if(checkDom && document.querySelector(tagName) == null){
    return;
  }
  
  if(async){
    import(url).catch(e => {
      console.error(`Errore nel caricamento del componente ${tagName}:`, e);
    });
  } else {
    await import(url);
  }
}
window.themeComponent = themeComponent;

for (const key of Object.keys(theme.resources)) {
  themeComponent(theme.resources[key], false);
}

// [perf: Fase 2 — caricamento on-demand dei componenti]
// Prima questo loop importava TUTTI i ~60 componenti su OGNI pagina (≈60 fetch +
// eval di moduli anche inutilizzati → main-thread work). Ora importa solo i
// componenti il cui tag è presente nel DOM iniziale; ogni componente auto-carica
// le proprie dipendenze (self-bootstrap in testa al modulo), quindi le classi base
// senza tag (mc-element/mc-shopify/mc-events/mc-input) arrivano da sole.
// Un MutationObserver copre i componenti iniettati DOPO il primo paint (item del
// carrello, risultati ricerca, paginazione, contenuti refreshable dell'app-bridge),
// così il gating non lascia mai un custom element privo di definizione.
//
// alwaysLoad: servizi globali (base) e superficie d'integrazione do-not-touch, che
// devono essere disponibili anche su pagine prive di componenti.
// tagOverride: gli unici componenti la cui key nella mappa ≠ tag reale — vanno
// osservati/gated sul tag effettivo, non sulla key.
const alwaysLoad = new Set(['mc-element', 'mc-shopify', 'mc-events', 'glamood-app-bridge', 'gl-sso']);
const tagOverride = { 'mc-video-player': 'video-player', 'mc-wishlist-count': 'wishlist-count' };
const selectorFor = (key) => tagOverride[key] || key;

const pendingComponents = new Map();
for (const key of Object.keys(theme.components)) {
  if (alwaysLoad.has(key) || document.querySelector(selectorFor(key))) {
    themeComponent(theme.components[key], false);
  } else {
    pendingComponents.set(key, theme.components[key]);
  }
}

if (pendingComponents.size) {
  const upgradePending = (node) => {
    if (!(node instanceof Element)) return;
    for (const key of [...pendingComponents.keys()]) {
      const sel = selectorFor(key);
      if (node.matches(sel) || node.querySelector(sel)) {
        themeComponent(pendingComponents.get(key), true);
        pendingComponents.delete(key);
      }
    }
  };
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) upgradePending(node);
    }
    if (!pendingComponents.size) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

class McImage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const img = this.querySelector('img');
    if(img.complete){
      this.classList.add('loaded');
      return;
    };
    img.addEventListener('load', () => {
      this.classList.add('loaded');
    });
  }
}
customElements.define('mc-image', McImage);